import { Config } from "../../domain";
import {
  ConfigRemoteDataSourceError,
  Endpoints,
  RemoteDataSource,
} from "../core";

export class ConfigRemoteDataSource extends RemoteDataSource {
  public async edit(config: {
    freeDeliveryMinPrice: number;
    deliveryPrice: number;
    pageSize: number;
  }): Promise<void> {
    try {
      const { deliveryPrice, freeDeliveryMinPrice, pageSize } = config;
      await this.post(Endpoints.editConfigs, {
        body: {
          free_delivery_min_price:
            freeDeliveryMinPrice === undefined ? "" : freeDeliveryMinPrice,
          delivery_price: deliveryPrice === undefined ? "" : deliveryPrice,
          page_size: pageSize === undefined ? "" : pageSize,
        },
      });
    } catch (error) {
      if (!error.response) throw ConfigRemoteDataSourceError.networkError();
      throw ConfigRemoteDataSourceError.serverError();
    }
  }

  public async getConfig(): Promise<Config> {
    try {
      const res = await this.get(Endpoints.listConfigs);
      if (res.data.length === 0) return Config.default();
      return new Config().deserialize(res.data[0]);
    } catch (error) {
      if (!error.response) throw ConfigRemoteDataSourceError.networkError();
      throw ConfigRemoteDataSourceError.serverError();
    }
  }
}
